<div class="app-setting-edit-dialog">
  <div class="dialog-header">
    <div>
      <div class="header-text">
        <h2>Edit App Setting</h2>
        <p class="setting-key">{{ data.setting.key }}</p>
        <p class="setting-description">{{ data.setting.description }}</p>
      </div>
    </div>
    <button mat-icon-button (click)="onCancel()" class="close-button" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="settingForm" class="setting-form">
      <!-- Data Type Info -->
      <div class="info-section">
        <mat-icon class="info-icon">info</mat-icon>
        <span class="info-text">
          Data Type: <strong>{{ data.setting.dataType }}</strong>
        </span>
      </div>

      <!-- Value Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Value</mat-label>
        @if (data.setting.dataType.toLowerCase() === 'json') {
          <textarea
            matInput
            formControlName="value"
            rows="6"
            placeholder="Enter value..."
          ></textarea>
        } @else {
          <input
            matInput
            formControlName="value"
            placeholder="Enter value..."
          />
        }
        @if (settingForm.get('value')?.invalid && settingForm.get('value')?.touched) {
          <mat-error>{{ getErrorMessage() }}</mat-error>
        }
      </mat-form-field>

      <!-- Status Toggle -->
      <div class="status-field">
        <div class="status-label">
          <span>Active</span>
          <span class="status-description">Enable or disable this setting</span>
        </div>
        <mat-slide-toggle
          formControlName="isActive"
          class="toggle-success"
          [hideIcon]="true"
        ></mat-slide-toggle>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isSaving">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="settingForm.invalid || isSaving"
    >
      @if (isSaving) {
        <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
      }
      Save
    </button>
  </mat-dialog-actions>
</div>
